<template>
  <v-container fill-height fluid tabindex="-1" ref="refSubsMainPanel" class="ma-0 pa-1" justify-center :class="isOnMobile ? '' : 'px-3'">
    <div style="width: 100%; min-height: 100%; max-width: 1000px" align-content="start">
      <v-stepper class="box-container pa-2" style="display: inline-flex; width: 100%" v-model="steps" vertical v-resize:debounce="recalcWidthHeight">
        <v-stepper-step class="row-header subtitle-2 ma-0 pa-0" :step="1" :complete="steps > 1">{{ 2 > steps ? s_Action : sub ? s_ActivatePlan : s_DeactivatePlan }}</v-stepper-step>
        <v-stepper-content class="row-content-limited ma-0 pa-0 ml-3" :step="1">
          <div class="pa-0" v-if="steps == 1" justify="center" align="center">
            <v-row class="ma-0 pa-3" align="center" justify="space-around">
              <t-button :btnIcon="'mdi-sticker-plus-outline'" :btnText="isOnMobile ? s_Activate : s_Activate + ' / ' + s_ChangePlan" :btnColor="'success'" @click.native="increaseSteps(true)" />
              <t-button :btnIcon="'mdi-sticker-minus-outline'" :btnText="isOnMobile ? s_Deactivate : s_DeactivatePlan" :btnColor="'error'" @click.native="increaseSteps(false)" />
            </v-row>
          </div>
        </v-stepper-content>
        <v-stepper-step class="row-header subtitle-2 ma-0 mt-3 pa-0" :step="2" :complete="steps > 2">{{ 3 > steps ? s_ChoosePlan : s_SubscriptionPlan + ": " + (sub ? chosenPlan.name : s_None) }}</v-stepper-step>
        <v-stepper-content class="row-content-limited ma-0 pa-0 ml-3" :step="2" style="overflow-y: auto">
          <div v-if="sub && steps == 2" class="pa-0" justify="center" align="center">
            <div class="ma-0 pa-0" style="width: 100%; overflow-x: auto; display: inline-flex" :style="isWithSmallWidth ? '' : 'justify-content: space-around;'" align="center">
              <t-subplan
                v-for="(plan, index) in getPlans"
                :disabledPlan="isDisabled(plan)"
                :key="index"
                :xs="colWi"
                @click.native="isDisabled(plan) ? '' : chosenPlan == plan ? (chosenPlan = null) : (chosenPlan = plan)"
                :subPlan="plan"
                :chosenSubPlan="chosenPlan"
              ></t-subplan>
            </div>
            <v-row class="ma-1 mt-2" justify="space-between">
              <t-button :btnIcon="'mdi-arrow-left'" :btnText="s_Backward" :btnColor="'warning'" @click.native="decreaseSteps()" />
              <t-button :btnIcon="'mdi-arrow-right'" :btnText="s_Continue" :btnColor="'success'" @click.native="increaseSteps()" :iconLeft="false" :btnDisabled="chosenPlan == null" />
            </v-row>
          </div>
        </v-stepper-content>
        <v-stepper-step class="row-header subtitle-2 ma-0 mt-3 pa-0" :step="3" :complete="steps > 3">{{ s_ChooseDevices }}</v-stepper-step>
        <v-stepper-content class="row-content-limited ma-0 pa-0 ml-3" :step="3">
          <div class="box-container ma-0 pa-0" v-if="steps == 3" ref="refContainer" justify="center" align="center">
            <v-col class="ma-3">
              <v-row class="ma-0 pa-0" :class="isOnMobile ? '' : 'px-2'">
                <v-text-field v-model="searchText" class="ma-0 pa-0 mr-3" :label="s_SearchByNameOrSN" hide-details></v-text-field>
                <v-combobox
                  class="ma-1 pa-0 subtitle-2"
                  v-model="chosenModel"
                  :items="models"
                  item-text="Name"
                  item-value="Name"
                  clearable
                  :label="s_Model"
                  hide-details
                  dense
                  :item-color="isInDarkMode ? '#FFFFFF' : ''"
                  :style="isOnMobile ? 'max-width: 120px' : 'max-width: 200px'"
                  :return-object="false"
                >
                  <template slot="prepend-inner">
                    <v-avatar v-if="chosenModel" size="26" class="ma-0 mr-2 pa-0" tile>
                      <v-img :src="models.find((m) => m.Name == chosenModel).Image" contain></v-img>
                    </v-avatar>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-avatar size="26" tile class="ma-0 mr-2 pa-0">
                      <v-img :src="data.item.Image" contain></v-img>
                    </v-avatar>
                    <span class="pl-2 subtitle-2">{{ data.item.Name }}</span>
                  </template>
                </v-combobox>
                <v-combobox
                  class="ma-1 pa-0 pl-2 subtitle-2"
                  v-model="chosenSimStatus"
                  :items="simStatuses"
                  clearable
                  :label="s_SimStatus"
                  hide-details
                  dense
                  :item-color="isInDarkMode ? '#FFFFFF' : ''"
                  :style="isOnMobile ? 'max-width: 120px' : 'max-width: 140px'"
                ></v-combobox>
              </v-row>
              <v-row v-if="getDevices.length == 0" class="ma-3" :style="'height: ' + (virtualScrollerHeight + 38) + 'px'">
                <v-avatar size="25" class="mr-3">
                  <v-icon color="red">mdi-alert</v-icon>
                </v-avatar>
                <span v-if="!!chosenModel || !!chosenSimStatus || !!searchText">{{ sub ? s_NoFilteredDevsForActivating : s_NoFilteredDevsForDeactivating }}</span>
                <span v-else>{{ sub ? s_NoDevsForActivating : s_NoDevsForDeactivating }}</span>
              </v-row>
              <div v-else>
                <v-row class="ma-0 pa-0" :class="isOnMobile ? '' : 'px-2'">
                  <v-switch inset dense :label="s_ChooseAll" v-model="chooseAll" @change="markAll"></v-switch>
                </v-row>
                <v-virtual-scroll v-if="showItems" ref="refVirtualScroll" :height="virtualScrollerHeight" :item-height="deviceHeight" :items="getDevices" :width="virtualScrollerWidth">
                  <template v-slot="{ item }">
                    <v-switch inset class="ma-0 pa-0" :class="isOnMobile ? 'px-1' : 'px-4'" dense v-model="chosenDevices" :value="`${item.sn}`" multiple hide-details :color="sub ? 'success' : Colors.IconColor">
                      <template v-slot:label>
                        <v-avatar size="26" tile class="ma-0 mr-2 pa-0">
                          <v-img :src="item.Image" width="auto" height="auto" contain></v-img>
                        </v-avatar>
                        <v-tooltip v-if="item.sim.activatedMo == false" :disabled="hideTooltips" bottom style="z-index: 10">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small right class="ma-0 mr-2 pa-0" color="error">mdi-sim-off</v-icon>
                          </template>
                          {{ s_DevWithStoppedSim }}
                        </v-tooltip>
                        <span :style="'white-space: pre;' + (isOnMobile ? 'font-size: 14px;' : '') + (found && found.sn == item.sn ? 'text-decoration: underline;' : '')">{{
                          item.Name + " (" + item.sn + ")" + (item.duprofile.csubscriptionPlan && item.duprofile.csubscriptionPlan.name ? ", " + s_CurrentPlan + " - " + item.duprofile.csubscriptionPlan.name : "")
                        }}</span>
                      </template>
                    </v-switch>
                  </template>
                </v-virtual-scroll>
              </div>
            </v-col>
            <v-divider class="mt-3"></v-divider>
            <v-row class="ma-1 pa-1" :style="'height: ' + buttonsHeight + 'px;'" align="center" justify="space-between">
              <t-button :btnIcon="'mdi-arrow-left'" :btnText="s_Backward" :btnColor="'warning'" @click.native="decreaseSteps()" />
              <t-button :btnIcon="'mdi-arrow-right'" :btnText="s_Continue" :btnColor="'success'" @click.native="increaseSteps()" :iconLeft="false" :btnDisabled="chosenDevices.length == 0" />
            </v-row>
          </div>
        </v-stepper-content>
        <v-stepper-step class="row-header subtitle-2 ma-0 mt-3 pa-0" :step="4" :complete="steps > 4">{{ `${s_ConfirmRequest} ${sub ? s_Activate : s_Deactivate}` }}</v-stepper-step>
        <v-stepper-content class="row-content-limited ma-0 pa-0 ml-3" :step="4">
          <div v-if="steps == 4" class="ma-0 pa-0" justify="center" align="center">
            <v-row class="ma-0 pa-0">
              <v-col class="ma-1 pa-0" cols="12">
                <v-simple-table :dense="isOnMobile" class="ma-0 pa-0">
                  <tbody>
                    <tr v-if="sub">
                      <td class="pl-3">{{ s_SubscriptionPlan }}</td>
                      <td>
                        <span v-if="chosenPlan">{{ chosenPlan.name }}</span>
                      </td>
                    </tr>
                    <tr v-if="!isOnMobile">
                      <td class="pl-3">{{ s_ChosenDevsFor + " " + (sub ? s_Activate : s_Deactivate) }}</td>
                      <td>
                        <span>{{ getChosenDevicesString }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pl-3">{{ s_CurrentlyChosenDevs }}</td>
                      <td>
                        <span>{{ chosenDevices.length }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="pl-3">{{ s_TotalChosenDevs }}</td>
                      <td>
                        <span>{{ getAllSubbedDevicesCount }}</span>
                      </td>
                    </tr>
                    <tr v-if="sub">
                      <td class="pl-3">{{ s_PriceDailyFor + " " + getAllSubbedDevicesCount + (getAllSubbedDevicesCount == 1 ? " " + s_Device : " " + s_Devices) }}</td>
                      <td align="right">
                        <span style="white-space: pre" v-if="chosenPlan">{{ getAllDevicesPricePerDay.toFixed(4) + " " + TR.MoneyAbbreviation + "\n" + toEuro(getAllDevicesPricePerDay).toFixed(4) + " " + TR.MoneyAbbreviation2 }}</span>
                      </td>
                    </tr>
                    <tr v-if="sub">
                      <td class="pl-3">{{ s_PriceMonthlyFor + " " + getAllSubbedDevicesCount + (getAllSubbedDevicesCount == 1 ? " " + s_Device : " " + s_Devices) }}</td>
                      <td align="right">
                        <span style="white-space: pre" v-if="chosenPlan">{{ (getAllDevicesPricePerDay * 30).toFixed(4) + " " + TR.MoneyAbbreviation + "\n" + toEuro(getAllDevicesPricePerDay * 30).toFixed(4) + " " + TR.MoneyAbbreviation2 }}</span>
                      </td>
                    </tr>
                    <tr v-if="sub">
                      <td class="pl-3">{{ s_PriceYearlyFor + " " + getAllSubbedDevicesCount + (getAllSubbedDevicesCount == 1 ? " " + s_Device : " " + s_Devices) }}</td>
                      <td align="right">
                        <span style="white-space: pre" v-if="chosenPlan">{{ (getAllDevicesPricePerDay * 365).toFixed(4) + +" " + TR.MoneyAbbreviation + "\n" + toEuro(getAllDevicesPricePerDay * 365).toFixed(4) + " " + TR.MoneyAbbreviation2 }}</span>
                      </td>
                    </tr>
                    <tr v-if="sub && user.inTrial" style="color: green; font-weight: bold">
                      <td class="pl-3">{{ s_PriceFreeTrial }}</td>
                      <td align="right">
                        <span color="success">{{ "0 " + s_MoneyAbbreviation }}</span>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="ma-0 pa-0 pt-3 px-2" :style="'height: ' + buttonsHeight + 'px;'" align="center" justify="space-between">
              <t-button :btnIcon="'mdi-arrow-left'" :btnText="s_Backward" :btnColor="'warning'" @click.native="decreaseSteps()" />
              <t-button :btnIcon="'mdi-checkbox-marked-circle-outline'" :btnText="s_Finish" :btnColor="'success'" @click.native="subscribe()" :iconLeft="false" />
            </v-row>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import bus, { g_Dialog, TR } from "../../main";

export default {
  props: {},

  data() {
    return {
      user: null,
      showItems: true,
      subPlanImg: require("@/assets/img/landing/Cards/Subscription_Plan_Empty.png"),
      virtualScrollerOffset: 0,
      fromAnotherMenu: false,
      buttonsHeight: 50,
      intervalRecalcSize: null,
      virtualScrollerWidth: "100%",
      virtualScrollerHeight: 300,
      steps: 1,
      sub: true,
      discounts: [],
      chosenPlan: null,
      subPlans: [],
      devices: [],
      chosenDevices: [],
      chosenModel: null,
      chosenSimStatus: null,
      simStatuses: [
        { text: TR.Active, value: true },
        { text: TR.Stopped, value: false },
      ],
      chooseAll: false,
      searchText: null,
      found: null,
      models: Object.values(bus.models).sort((a, b) => {
        return a.Name > b.Name;
      }),
      TR: TR,
      s_Finish: TR.Finish,
      s_PriceFreeTrial: TR.PriceFreeTrial,
      s_PriceDailyFor: TR.PriceDailyFor,
      s_PriceMonthlyFor: TR.PriceMonthlyFor,
      s_PriceYearlyFor: TR.PriceYearlyFor,
      s_Device: TR.Device,
      s_Devices: TR.Devices,
      s_TotalChosenDevs: TR.TotalChosenDevs,
      s_CurrentlyChosenDevs: TR.CurrentlyChosenDevs,
      s_ChosenDevsFor: TR.ChosenDevsFor,
      s_ConfirmRequest: TR.ConfirmRequest,
      s_CurrentPlan: TR.CurrentPlan,
      s_DevWithStoppedSim: TR.DevWithStoppedSim,
      s_ChooseAll: TR.ChooseAll,
      s_NoDevsForActivating: TR.NoDevsForActivating,
      s_NoDevsForDeactivating: TR.NoDevsForDeactivating,
      s_NoFilteredDevsForActivating: TR.NoFilteredDevsForActivating,
      s_NoFilteredDevsForDeactivating: TR.NoFilteredDevsForDeactivating,
      s_SimStatus: TR.SimStatus,
      s_Model: TR.Model,
      s_SearchByNameOrSN: TR.SearchByNameOrSN,
      s_ChooseDevices: TR.ChooseDevices,
      s_Continue: TR.Continue,
      s_Backward: TR.Backward,
      s_None: TR.None,
      s_SubscriptionPlan: TR.SubscriptionPlan,
      s_ChoosePlan: TR.ChoosePlan,
      s_Action: TR.Action,
      s_ActivatePlan: TR.ActivatePlan,
      s_DeactivatePlan: TR.DeactivatePlan,
      s_Activate: TR.Activate,
      s_Deactivate: TR.Deactivate,
      s_ChangePlan: TR.ChangePlan,
    };
  },
  computed: {
    deviceHeight() {
      return this.isOnMobile ? 45 : 35;
    },
    colWi() {
      return Math.ceil(12 / this.getPlans.length);
    },
    getChosenDevicesString() {
      var str = this.chosenDevices.join(", ");
      if (str.length > 200) return str.substring(0, 200) + "...";
      return str;
    },
    getDevices() {
      if (!this.chosenPlan) {
        return [];
      }
      if (this.sub) {
        return this.devices
          .filter(
            (item) =>
              item.duprofile &&
              item.duprofile.cosmosableDevice &&
              (this.chosenSimStatus == null || item.sim.activatedMo == this.chosenSimStatus.value) &&
              (!this.chosenModel || item.model.name == this.chosenModel) &&
              (!item.duprofile.csubscriptionPlan || item.duprofile.csubscriptionPlan.id != this.chosenPlan.id)
          )
          .filter((d) => !this.searchText || d.sn.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1 || d.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1);
        // && (item.duprofile.csubscriptionPlan == null || item.duprofile.csubscriptionPlan.id == -1));
      } else {
        return this.devices
          .filter(
            (item) =>
              item.duprofile &&
              item.duprofile.cosmosableDevice &&
              (this.chosenSimStatus == null || item.sim.activatedMo == this.chosenSimStatus.value) &&
              (!this.chosenModel || item.model.name == this.chosenModel) &&
              item.duprofile.csubscriptionPlan &&
              item.duprofile.csubscriptionPlan.id > -1
          )
          .filter((d) => !this.searchText || d.sn.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1 || d.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1);
      }
    },
    getPlans() {
      if (!this.subPlans) return [];
      return this.subPlans.filter((p) => p.id != -1);
    },
    getPreviouslySubbedDevices() {
      return this.devices.filter((d) => d.duprofile && d.duprofile.csubscriptionPlan && d.duprofile.csubscriptionPlan.id > -1 && this.chosenDevices.indexOf(d.sn) == -1);
    },
    getAllSubbedDevicesCount() {
      return this.getPreviouslySubbedDevices.length + this.chosenDevices.length;
    },
    getAllDevicesPricePerDay() {
      var sum = 0;
      this.getPreviouslySubbedDevices.forEach((d) => (sum += (d.duprofile.csubscriptionPlan.pricePerDay * (100 - this.discountPercent)) / 100));
      sum += this.chosenDevices.length * ((this.chosenPlan.pricePerDay * (100 - this.discountPercent)) / 100);
      return sum;
    },
    discountPercent() {
      const dc = this.getPreviouslySubbedDevices.length + this.chosenDevices.length;
      var discPerc = 0;
      if (dc > 0) {
        var fdisc = this.discounts.find((d) => d.fuCount == dc);
        if (fdisc) {
          discPerc = fdisc.percent;
        } else {
          discPerc = 50;
        }
      }
      return discPerc;
    },
  },
  methods: {
    setTitleAndData(meta, error) {
      this.title = meta.title;
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.user = DataManager.getData(DataManager.DataType.user, true);
        this.devices = DataManager.getData(DataManager.DataType.devices, true).slice();
        DataManager.loadData(DataManager.DataType.subscription_plans, (err) => {
          if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            this.subPlans = DataManager.getData(DataManager.DataType.subscription_plans, true).map((plan) => ({
              id: plan.id,
              name: plan.name,
              price: plan.price,
              pricePerDay: plan.pricePerDay,
              description: plan.description,
            }));
          } else {
            this.dialogLoader.showError(err.Message, { location: "center" });
          }
        });
      } else {
        this.dialogLoader.showError(TR.Error + "! " + error.Message);
      }
    },
    search() {
      let devIndex = this.getDevices.findIndex((dev) => dev.sn.toLowerCase().contains(this.searchText.toLowerCase()));
      if (devIndex == -1) {
        devIndex = this.getDevices.findIndex((dev) => dev.Name.toLowerCase().contains(this.searchText.toLowerCase()));
      }
      if (devIndex != -1) {
        this.found = this.getDevices[devIndex];
        this.setFocusOnDevice(devIndex);
      } else {
        this.setFocusOnDevice(-1);
      }
    },
    decreaseSteps() {
      this.steps--;
      if (!this.sub && this.steps == 2) {
        this.steps--;
      }
      if (this.steps == 1) {
        this.sub = true;
        this.chosenPlan = null;
        this.chosenDevices = [];
      }
      // setTimeout(() => {
      //   this.$nextTick(() => {
      //     this.$refs.refSubsMainPanel.scrollTop = this.$refs.refSubsMainPanel.scrollHeight;
      //   }, 500);
      // });
    },
    increaseSteps(activate) {
      if (activate != undefined) {
        this.sub = activate;
        if (!this.sub) {
          this.chosenPlan = this.subPlans.find((p) => p.id == -1);
        }
      }
      this.steps++;
      if (this.steps == 2) {
        if (!this.sub) {
          this.steps++;
        }
      }
      if (this.steps == 3 && this.chosenDevices.length > 0 && this.fromAnotherMenu) {
        this.fromAnotherMenu = false;
        this.steps = 4;
      }
      // if (this.steps == 3) {
      //   this.$nextTick(() => {
      //     setTimeout(() => {
      //       this.$refs.refSubsMainPanel.scrollTop = this.$refs.refSubsMainPanel.scrollHeight;
      //     });
      //   }, 500);
      // }
    },
    setFocusOnDevice(deviceIndex) {
      this.$nextTick(() => {
        if (this.$refs.refVirtualScroll) {
          this.$refs.refVirtualScroll.$el.scrollTo(0, deviceIndex * this.deviceHeight);
        }
      });
    },
    switchClick(sn) {
      var idx = this.chosenDevices.indexOf(sn);
      if (idx == -1) {
        this.chosenDevices.push(sn);
      } else {
        this.chosenDevices.splice(idx, 1);
      }
    },
    markAll() {
      if (this.chooseAll) {
        this.getDevices.forEach((d) => {
          this.chosenDevices.push(d.sn);
        });
      } else {
        this.chosenDevices = [];
      }
    },
    recalcWidthHeight() {
      if (this.intervalRecalcSize) clearTimeout(this.intervalRecalcSize);
      this.intervalRecalcSize = setTimeout(() => {
        if (!this.$refs.refContainer || !this.$refs.refVirtualScroll) {
          return;
        }
        this.virtualScrollerWidth = this.$refs.refContainer.clientWidth - 24;
        this.virtualScrollerHeight = window.innerHeight - this.$vuetify.application.top - this.$vuetify.application.footer - this.getBannerHeight - 4 * 55 - this.buttonsHeight * 3;
        //this.virtualScrollerHeight = this.$refs.refContainer.clientHeight;
        if (this.getDevices && this.virtualScrollerHeight > this.deviceHeight * this.getDevices.length) this.virtualScrollerHeight = this.deviceHeight * this.getDevices.length;
      }, 1000);
    },
    setFocus(on) {
      if (on) {
        this.$nextTick(() => {
          if (this.$refs.refVirtualScroll) {
            this.$refs.refVirtualScroll.$el.scrollTop = 0;
            this.$nextTick(() => {
              this.$refs.refVirtualScroll.$el.scrollTop = this.virtualScrollerOffset;
            });
          }
        });
      } else this.virtualScrollerOffset = this.$refs.refVirtualScroll.$el.scrollTop;
    },
    async subscribe() {
      var devs = this.devices.filter((d) => this.chosenDevices.indexOf(d.sn) !== -1);
      if (!this.sub) {
        this.chosenPlan = this.subPlans.find((p) => p.id == -1);
      }
      var plan = this.chosenPlan;
      await g_Dialog.show(g_Dialog.dialog_types.loader, null, { message: TR.SendingSubscriptionRequestPleaseWait });
      DataManager.subscribe(devs, plan, async (err) => {
        await this.dialog.close().then(() => {
          if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            this.steps = 1;
            this.chosenPlan = null;
            this.chosenDevices.splice(0, this.chosenDevices.length);
            this.dialogLoader.hide();
            this.dialogLoader.showInfo(TR.SuccessfulSubscription);
            this.devices = DataManager.getData(DataManager.DataType.devices, true).slice();
            bus.$emit(bus.EVENT_Device_subscribtion_changed, null);
          } else {
            var msg = err.Message;
            if (err.ErrorDetails) {
              err.ErrorDetails.forEach((d) => (msg += "\n" + d.Description));
            }
            this.dialogLoader.showError(msg, { location: "center" });
          }
        });
      });
    },
    isDisabled(plan) {
      if (plan && this.fromAnotherMenu && this.chosenDevices.length == 1) {
        var d = this.devices.find((d) => d.sn == this.chosenDevices[0]);
        return d && d.duprofile && d.duprofile.csubscriptionPlan && d.duprofile.csubscriptionPlan.id == plan.id;
      } else {
        return false;
      }
    },
    refreshItems() {
      this.showItems = false;
      this.$nextTick(() => {
        this.showItems = true;
        this.recalcWidthHeight();
      });
    },
  },
  watch: {
    chosenSimStatus() {
      this.refreshItems();
    },
    searchText() {
      this.refreshItems();
    },
    chosenModel() {
      this.refreshItems();
    },
    steps() {
      this.recalcWidthHeight();
    },
    // chosenDevices() {},
  },
  created() {
    bus.$on(bus.EVENT_Device_want_to_unsubscribe, (item) => {
      this.fromAnotherMenu = true;
      this.steps = 0;
      this.sub = false;
      this.$nextTick(() => {
        this.chosenDevices = [];
        this.chosenPlan = this.subPlans.find((p) => p.id == -1);
        this.steps = 3;
        this.chosenDevices.push(item.sn);
      });
    });
    bus.$on(bus.EVENT_Device_want_to_subscribe, (item, plan) => {
      this.fromAnotherMenu = true;
      this.steps = 0;
      this.sub = true;
      var havetoWarn = false;
      this.$nextTick(() => {
        this.chosenDevices = [];
        this.chosenPlan = null;
        this.steps = 2;
        if (item instanceof Array) {
          this.chosenDevices.push(...item.map((i) => i.sn));
          havetoWarn = !!item.find((i) => i.IsOldFuvas);
        } else {
          this.chosenDevices.push(item.sn);
          havetoWarn = item.IsOldFuvas;
        }
        if (plan) {
          this.steps = 4;
          this.chosenPlan = plan;
        }
        this.$nextTick(() => {
          if (havetoWarn) {
            this.dialogLoader.showInfo("За Tremol V-KL устройства е необходимо сервизната фирма да актуализира абонираните ФУВАС устройства!", { timeout: 10000 });
          }
        });
      });
    });
  },
  mounted() {
    this.discounts = DataManager.getData(DataManager.DataType.discounts);
  },
};
</script>
<style>
</style>